import React from 'react'

import { Box, Card, CardBody, Flex, Stat, StatLabel, StatNumber, Text, useColorMode } from '@chakra-ui/react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

interface ChartProps {
}

const data = [
  {
    name: 'Page A',
    uv: 1000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 3200,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 2000,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2200,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 2800,
    pv: 4300,
    amt: 2100,
  },
]

function Chart(props: ChartProps) {

  const {} = props
  const { colorMode } = useColorMode()
  
  return (
    <Card w="full" h="126px" shadow="none" bg={colorMode == "light" ? "skySoft" : "alphaWhite005"} borderRadius="8px">
      <CardBody p="16px 0 0" h="full">
        <Flex direction="column" h="full">
          <Stat px="24px">
            <StatLabel>Profit</StatLabel>
            <StatNumber fontSize="18px" lineHeight="16px">$<Text fontSize="18px" lineHeight="16px" as="strong">454.35</Text></StatNumber>
          </Stat>
          <Box w="full" h="40px" mt="auto" position="relative">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart
                data={data}
                height={40}
                margin={{top: 1, right: 0, bottom: 0, left: 0}}
              >
                <defs>
                  <linearGradient id="greenGradient" x1="86.5" y1="-36.0635" x2="86.0969" y2="35.9991" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#75C113" stop-opacity="0"/>
                    <stop offset="1" stop-color={colorMode == "light" ? "#FBFBFB" : "rgba(19, 25, 58, 0.3)"} />
                  </linearGradient>
                </defs>
                <defs>
                  <linearGradient id="redGradient" x1="86.5" y1="-40.0635" x2="86.0969" y2="31.9991" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F35E5E" stop-opacity="0"/>
                    <stop offset="1" stop-color={colorMode == "light" ? "#FBFBFB" : "rgba(19, 25, 58, 0.3)"} />
                  </linearGradient>
                </defs>
                <Area type="monotone" dataKey="uv" stroke="#75C113" fill="url(#greenGradient)" />
              </AreaChart>
            </ResponsiveContainer>
            <Box w="full" h="20px" position="absolute" bottom="0" left="0" bgGradient={colorMode == "light" ? "linear(to-b, transparent, softGray)" : "linear(to-b, transparent, transparent)"}></Box>
          </Box>
        </Flex>
      </CardBody>
    </Card>
  )
}

export default Chart